import * as React from "react";

import { Box, CssBaseline } from "@mui/material";
import { ThemeContext } from "./context";
import { Application } from "./components";

function App() {
  return <Application />;
}

export default App;
